import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Tooltip } from 'framework/ui/mui-builder';
import PositionSlotValidationErrorsTooltip from './PositionSlotValidationErrorsTooltip';

type PositionSlotValidationWarningIconProps = {
  errors: string[];
};

const PositionSlotValidationWarningIcon = ({ errors }: PositionSlotValidationWarningIconProps) => {
  if (!errors.length) return null;

  return (
    <Tooltip title={<PositionSlotValidationErrorsTooltip errors={errors} />}>
      <WarningAmberIcon color="warning" fontSize="small" />
    </Tooltip>
  );
};

export default PositionSlotValidationWarningIcon;
